module.exports = __webpack_public_path__ + "static/media/DC_O_Embroidery_Bicocca_White_IndBlue.d5e96bfd.png";